var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalusuarioCerrarsesionActivo24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 6C16.75 3.37665 14.6234 1.25 12 1.25H7C4.37665 1.25 2.25 3.37665 2.25 6V18C2.25 20.6234 4.37665 22.75 7 22.75H12C14.6234 22.75 16.75 20.6234 16.75 18V16C16.75 15.5858 16.4142 15.25 16 15.25C15.5858 15.25 15.25 15.5858 15.25 16V18C15.25 19.7949 13.7949 21.25 12 21.25H7C5.20507 21.25 3.75 19.7949 3.75 18V6C3.75 4.20507 5.20507 2.75 7 2.75H12C13.7949 2.75 15.25 4.20507 15.25 6V8C15.25 8.41421 15.5858 8.75 16 8.75C16.4142 8.75 16.75 8.41421 16.75 8V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7626 11.8232C20.8602 11.9209 20.8602 12.0791 20.7626 12.1768L18.4697 14.4697C18.1768 14.7626 18.1768 15.2374 18.4697 15.5303C18.7626 15.8232 19.2374 15.8232 19.5303 15.5303L21.8232 13.2374C22.5066 12.554 22.5066 11.446 21.8232 10.7626L19.5303 8.46967C19.2374 8.17678 18.7626 8.17678 18.4697 8.46967C18.1768 8.76256 18.1768 9.23744 18.4697 9.53033L20.7626 11.8232Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 12C8.25 12.4142 8.58579 12.75 9 12.75L21 12.75C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25L9 11.25C8.58579 11.25 8.25 11.5858 8.25 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalusuarioCerrarsesionActivo24X24);
export default __webpack_public_path__ + "static/media/MODAL USUARIO-CERRAR SESION-ACTIVO_24X24.9296d8dbd66f6c639e6fef810228cc62.svg";
export { ForwardRef as ReactComponent };